import { render, staticRenderFns } from "./WizardHeader.vue?vue&type=template&id=188c6388&scoped=true&"
import script from "./WizardHeader.vue?vue&type=script&lang=ts&"
export * from "./WizardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./WizardHeader.vue?vue&type=style&index=0&id=188c6388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c6388",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188c6388')) {
      api.createRecord('188c6388', component.options)
    } else {
      api.reload('188c6388', component.options)
    }
    module.hot.accept("./WizardHeader.vue?vue&type=template&id=188c6388&scoped=true&", function () {
      api.rerender('188c6388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/WizardHeader.vue"
export default component.exports